import type { Profile } from 'app-components/flux/profile/profileTypes';
import type { Dataset } from './datasetsTypes';

export function isWindowsDataset(dataset: Dataset) {
  if (dataset) {
    return dataset.createdByClientId === 'quicken_windows';
  }
  return true; // default to windows behavior
}

export const hasActiveEntitlement = (dataset: Dataset) =>
  dataset.entitlements?.find((entitlement) => entitlement.id?.startsWith('ACME_') && entitlement.active);

export const makeQEMDatasetNameFromProfile = (profile: Profile) => {
  const profileName = profile?.lastName || profile?.firstName;
  return `${profileName ? `${profileName}'s` : 'My'} Household`;
};

export const defaultQEMDatasetName = (currentName: string, profile: Profile) => {
  if (currentName?.indexOf('Finances') === -1 && currentName?.indexOf('My Household') === -1) {
    // doesn't have default 'Finances' or 'My Household'
    return currentName;
  }
  return makeQEMDatasetNameFromProfile(profile);
};
